
    import './styles.scoped.css';
    export default {
  "segment": "awsui_segment_8cbea_rjyg4_17",
  "full-width": "awsui_full-width_8cbea_rjyg4_44",
  "refresh": "awsui_refresh_8cbea_rjyg4_47",
  "disabled": "awsui_disabled_8cbea_rjyg4_53",
  "selected": "awsui_selected_8cbea_rjyg4_116",
  "icon": "awsui_icon_8cbea_rjyg4_127",
  "with-text": "awsui_with-text_8cbea_rjyg4_131",
  "with-no-text": "awsui_with-no-text_8cbea_rjyg4_140",
  "root": "awsui_root_8cbea_rjyg4_145",
  "segment-part": "awsui_segment-part_8cbea_rjyg4_177",
  "grouped": "awsui_grouped_8cbea_rjyg4_202",
  "grouped-only": "awsui_grouped-only_8cbea_rjyg4_202",
  "grouped-vertical": "awsui_grouped-vertical_8cbea_rjyg4_206",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_8cbea_rjyg4_217",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_8cbea_rjyg4_221",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_8cbea_rjyg4_227",
  "grouped-vertical-first": "awsui_grouped-vertical-first_8cbea_rjyg4_231",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_8cbea_rjyg4_235",
  "grouped-vertical-last": "awsui_grouped-vertical-last_8cbea_rjyg4_241",
  "grouped-with-action": "awsui_grouped-with-action_8cbea_rjyg4_245",
  "select": "awsui_select_8cbea_rjyg4_116",
  "segment-count-2": "awsui_segment-count-2_8cbea_rjyg4_262",
  "segment-count-3": "awsui_segment-count-3_8cbea_rjyg4_269",
  "segment-count-4": "awsui_segment-count-4_8cbea_rjyg4_276",
  "segment-count-5": "awsui_segment-count-5_8cbea_rjyg4_283",
  "segment-count-6": "awsui_segment-count-6_8cbea_rjyg4_290",
  "disabled-reason-tooltip": "awsui_disabled-reason-tooltip_8cbea_rjyg4_297"
};
  